import * as React from 'react'
import { connect } from 'react-redux'

import ButtonExtended from 'components/ButtonExtended'
import { City } from '../../../data/models/funnelOrder/cities'
import { destinationEnum } from '../../../data/models/funnelOrder/destination'
import {
  filterDestination,
  getExcludedCitiesContentKey,
  getMaxExcludedCities,
} from '../../../data/models/funnelOrder/excludedCities'
import { Theme } from '../../../data/models/funnelOrder/theme'
import { AppState } from '../../../data/state'
import FlyExcludeModal from '../../../elements/modals/FlyExcludeModal'
import Content from '../../shared/content'

interface ExcludeCitiesProps {
  theme: Theme
  excludedCities: City[]
  destination: destinationEnum
}

interface ExcludeCitiesState {
  showExcludeCities: boolean
}

class ExcludeCities extends React.Component<
  ExcludeCitiesProps,
  ExcludeCitiesState
> {
  constructor(props: ExcludeCitiesProps) {
    super(props)
    this.state = {
      showExcludeCities: false,
    }
  }

  public toggleExcludeCities = () => {
    this.setState({
      showExcludeCities: !this.state.showExcludeCities,
    })
  }

  public render() {
    const { theme, destination, excludedCities } = this.props

    const max = getMaxExcludedCities(theme, destination)
    const filtered = filterDestination(
      excludedCities,
      theme,
      destination || destinationEnum.allOfEurope,
      max,
    )
    const contentKey = getExcludedCitiesContentKey(
      theme,
      destination,
      'exclude-cities-subheading',
    )

    return (
      <>
        <ButtonExtended
          i={filtered.length}
          iMax={max}
          isActive={filtered.length > 0}
          header={
            <Content contentKey="exlude-cities-heading">
              Exclude cities?
            </Content>
          }
          subHeader={
            <Content contentKey={contentKey}>
              {`Feel free to exclude ${contentKey} cities`}
            </Content>
          }
          onClick={this.toggleExcludeCities}
        />
        {this.state.showExcludeCities ? (
          <FlyExcludeModal
            backButton
            hideClose
            destination={destination}
            onClose={() => this.setState({ showExcludeCities: false })}
          />
        ) : null}
      </>
    )
  }
}

export default connect((state: AppState) => ({
  excludedCities: state.funnelOrder.excludedCitiesIds,
  theme: state.funnelOrder.theme,
}))(ExcludeCities)
